// extracted by mini-css-extract-plugin
export var text = "_4y-0";